import moment from "moment";
import React, { useState, useEffect, useCallback } from "react";
import { Alert, Table } from "react-bootstrap";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import SearchForm from "../../../../components/form/SearchForm.jsx";
import TableFooter from "../../../../components/TableFooter.jsx";
import genericTranslations from "../../../../utils/genericTranslations.js";
import {
  selectContentItemsSortedByUpdatedAt,
  selectIsLoadingContentItems,
} from "../../selectors";
import { fetchContentItems } from "../../thunks.js";

const ContentItems = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [searchTitle, setSearchTitle] = useState("");
  const pageSize = 10;

  const contentItems = useSelector(selectContentItemsSortedByUpdatedAt);
  const isLoading = useSelector(selectIsLoadingContentItems);

  const fetchData = useCallback(async () => {
    try {
      const pagesFromResponse = await dispatch(
        fetchContentItems({ page, pageSize, searchTitle }),
      );
      setPages(pagesFromResponse);
    } catch (err) {
      setError(err);
      setPage(1);
      setPages(0);
    }
  }, [dispatch, page, pageSize, searchTitle]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const mapContentItemToTableRow = (item) => (
    <tr key={`content-item-${item.id}`}>
      <td>
        <Link to={`/arrivideo/contentitem/edit/${item.id}`}>{item.title}</Link>
      </td>
      <td>{item.type}</td>
      <td>{moment(item.updatedAt).format("LLL")}</td>
    </tr>
  );

  const handleSearchChange = (e) => {
    setSearchTitle(e.target.value);
    if (page !== 1) {
      setPage(1);
    }
  };

  const onSelectPage = (newPage) => {
    setPage(newPage);
  };

  const dismissError = () => {
    setError(null);
  };

  return (
    <div>
      {error && (
        <Alert variant="danger" onClose={dismissError} dismissible>
          <Alert.Heading>
            {intl.formatMessage(genericTranslations.errorMessage)}
          </Alert.Heading>
          <p>{error.toString()}</p>
        </Alert>
      )}

      <SearchForm
        searchTitle={searchTitle}
        onSearchChange={handleSearchChange}
      />

      {isLoading && (
        <span className="align-middle">
          {intl.formatMessage(genericTranslations.loadingInProgress)}
        </span>
      )}

      {!isLoading && (!contentItems || contentItems.length === 0) && (
        <span className="align-middle">
          {intl.formatMessage(genericTranslations.nothingFound)}
        </span>
      )}

      {!isLoading && contentItems && contentItems.length > 0 && (
        <Table responsive>
          <thead>
            <tr>
              <td>{intl.formatMessage(genericTranslations.title)}</td>
              <td style={{ width: 100 }}>Type</td>
              <td style={{ width: 200 }}>
                {intl.formatMessage(genericTranslations.updatedAt)}
              </td>
            </tr>
          </thead>
          <tbody>{contentItems.map(mapContentItemToTableRow)}</tbody>
        </Table>
      )}

      <TableFooter
        actionPath="/arrivideo/contentitem/add"
        onSelectPage={onSelectPage}
        page={page}
        pages={pages}
      />
    </div>
  );
};

export default ContentItems;
